/* eslint-disable @next/next/no-img-element */
import React, { useEffect, useState } from "react";
import { MapContainer, useMap, TileLayer } from "react-leaflet";

const MapListing = ({ location }) => {
  const [focus, setFocus] = useState(location);

  useEffect(() => {
    console.log("location", location);
    if (location) {
      setFocus(location);
    }
  }, [location]);

  const ChangeView = ({ center, zoom }) => {
    const map = useMap();
    map.setView(center, zoom);
    return null;
  };

  return (
    <MapContainer
      center={focus}
      zoom={19}
      scrollWheelZoom={false}
      className="w-full h-full flex"
    >
      <TileLayer attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
        url='https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png' />
      <ChangeView center={focus} zoom={19} />
    </MapContainer>
  );
};

export default MapListing;
